"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPaddingClassNames = exports.paddingSpacing = void 0;

var clsx_1 = __importDefault(require("clsx"));

var _1 = require("./");

var basePadding = {};
exports.paddingSpacing = _1.spacingValues.reduce(function (prev, curr, index) {
  var _Object$assign;

  return Object.assign(Object.assign({}, prev), (_Object$assign = {}, _Object$assign["&.pt-" + index + ", &.p-" + index + ", &.py-" + index] = {
    paddingTop: curr + " !important"
  }, _Object$assign["&.pr-" + index + ", &.p-" + index + ", &.px-" + index] = {
    paddingRight: curr + " !important"
  }, _Object$assign["&.pb-" + index + ", &.p-" + index + ", &.py-" + index] = {
    paddingBottom: curr + " !important"
  }, _Object$assign["&.pl-" + index + ", &.p-" + index + ", &.px-" + index] = {
    paddingLeft: curr + " !important"
  }, _Object$assign));
}, basePadding);

var createPaddingClassNames = function createPaddingClassNames(props) {
  var classNames = [];

  if (props.padding) {
    var _props$padding = props.padding,
        x = _props$padding.x,
        y = _props$padding.y,
        left = _props$padding.left,
        right = _props$padding.right,
        top = _props$padding.top,
        bottom = _props$padding.bottom;
    classNames.push(typeof props.padding === 'number' || props.padding === 'auto' ? "p-" + props.padding : '');
    classNames.push(x !== undefined ? "px-" + x : '');
    classNames.push(y !== undefined ? "py-" + y : '');
    classNames.push(left !== undefined ? "pl-" + left : '');
    classNames.push(right !== undefined ? "pr-" + right : '');
    classNames.push(top !== undefined ? "pt-" + top : '');
    classNames.push(bottom !== undefined ? "pb-" + bottom : '');
  }

  return clsx_1.default.apply(clsx_1, classNames);
};

exports.createPaddingClassNames = createPaddingClassNames;